import {Component, input} from "@angular/core";

@Component({
	selector: "sim-session-run-vector",
	templateUrl: "./session-run-vector.component.html",
	styleUrl: "./session-run-vector.component.scss",
	imports: [],
})
export class SessionRunVectorComponent {
	public readonly index = input.required<number>();
	public readonly size = input<"large" | "small">("large");
}
